<script>
	import Helper from '../../Classes/Helper';
	import Menu from '../../Stores/Menu';
	import Product from '../../Stores/Product';

	export let title = '';
	export let menu = [];

	function itemClick(item) {
		for (let item of menu) item.active = false;
		item.active = true;
		if (item.on_click) item.on_click();
		menu = menu;

		const data = Menu.getData();
		data.scroll = item.scroll || '';
		data.open = false;
		Menu.setData(data);
	}
</script>

<style>
	/* Title */

	div.zes-groups-title {
		display: flex;
		padding: .15em 1.25em .75em 1.25em;
		margin-bottom: .8em;
	}

	div.zes-groups-title > div:nth-child(1) {
		flex-grow: 1;
	}

	div.zes-groups-title > div:nth-child(1) div {
		font-size: 2.25em;
		font-weight: 400;
		letter-spacing: -.025em;
		color: var(--zes-1-1);
	}

	div.zes-groups-title > div:nth-child(1) span {
		font-size: .75em;
		font-weight: 300;
		color: var(--zes-3-1);
		display: block;
	}

	div.zes-groups-title > div:nth-child(1) span b {
		font-weight: 500;
		padding: 0 .5em;
		border-radius: .25em;
		background: hsl(0deg 0% 95%);
	}

	div.zes-groups-title > div:nth-child(2) {
		padding-top: 1em;
		padding-left: 2em;
		display: none;
	}

	div.zes-groups-title > div:nth-child(2) i {
		font-size: 1.75em;
		color: var(--zes-1-2);
	}

	/* Group */

	div.zes-groups-steps {
		flex-grow: 1;
	}

	div.zes-groups-steps > div.zes-active {
		background: var(--zes-1-4);
	}

	div.zes-groups-group {
		display: flex;
		padding: .75em 1em .75em 1.25em;
		border-bottom: 1px solid hsl(206deg 75% 85% / .5);
		cursor: pointer;
	}

	div.zes-groups-group:hover {
		background: hsl(0deg 0% 0% / .025);
	}

	div.zes-groups-group > div > i {
		color: var(--zes-3-2);
		margin-top: .15em;
		margin-right: 1em;
	}

	div.zes-groups-group div div {
		font-size: .95em;
		font-weight: 700;
		color: var(--zes-3-1);
	}

	div.zes-groups-steps > div.zes-active div {
		color: var(--zes-1-2);
	}

	div.zes-groups-steps > div.zes-active > div > i {
		color: var(--zes-1-3);
	}

	div.zes-groups-group div span:empty {
		display: none;
	}

	div.zes-groups-group div span {
		font-size: .85em;
		font-weight: 600;
		margin-top: .25em;
		color: var(--zes-1-3);
	}

	div.zes-groups-group div span i {
		margin-right: .25em;
		opacity: .5;
	}

	/* Styles */

	div.zes-groups-group.zes-success *:not(span) {
		color: var(--zes-2-1) !important;
	}

	div.zes-groups-group.zes-success span {
		color: var(--zes-2-2) !important;
	}

	div.zes-groups-group.zes-error *:not(span) {
		color: var(--zes-4-1) !important;
	}

	div.zes-groups-group.zes-error span {
		color: var(--zes-4-2) !important;
	}

	div.zes-groups-group.zes-attention {
		background-color: hsl(95deg 70% 40% / .1);
	}

	div.zes-groups-group.zes-attention * {
		color: var(--zes-2-1) !important;
	}

	/* Menu */

	div.zes-groups-menu {
		margin-left: 2.5em;
		cursor: pointer;
	}

	div.zes-groups-menu:empty {
		display: none;
	}

	div.zes-groups-menu div {
		font-size: .85em;
		font-weight: 600;
		color: var(--zes-3-1);
		padding: .6em 1.5em .6em .75em;
		border-bottom: 1px solid hsl(206deg 75% 85% / .5);
		border-left: 2px solid transparent;
		position: relative;
	}

	div.zes-groups-menu div:hover {
		background: hsl(0deg 0% 0% / .025);
		border-left: 2px solid var(--zes-3-2);
	}

	div.zes-groups-menu div i {
		position: absolute;
		padding-top: .4em;
		right: .5em;
	}

	div.zes-groups-menu div.zes-active {
		font-weight: 600;
		color: var(--zes-1-2);
		border-left: 2px solid var(--zes-1-3);
		background: hsl(206deg 75% 44% / .025);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-groups {
			flex-grow: 1;
			padding-top: 1em;
			border-right: none;
			background-size: 130%, 100%;
		}

		div.zes-groups-title > div:nth-child(2) {
			display: block;
		}
	}
</style>

<div class="zes-groups-title">
	<div>
		<div>{title}</div>
	</div>
	<div on:click="{event => $Menu.open = false}">
		<i class="fa-solid fa-xmark-large"></i>
	</div>
</div>
<div class="zes-groups-steps">
	{#each menu as item}
		<div on:click="{event => itemClick(item)}" class="zes-groups-group zes-{item.style}" class:zes-active="{item.active}">
			<div>
				<i class="fa-regular fa-{item.icon}"></i>
			</div>
			<div>
				<div>{item.label}</div>
			</div>
		</div>
	{/each}
</div>